import { MergeRequest } from '../'
import { branch } from '../constants'

module.exports = (transaction) ->
  { className } = MergeRequest
  await new Weaver.Node(className).set('name', className).save({ transaction, branch, commitMessage: "Add Merge Request Migration." })
